import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { ReqBoardApplyList } from "@/types";
import { AxiosResponse } from "axios";
// import { AxiosResponse } from "axios";

export default {
    async list(param: types.ReqBoardListForAdmin): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/list", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async listForActivity(param: types.ReqBoardListForActivity): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/activity/list", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async listForActivityManage(param: types.ReqBoardListForActivityManage): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/activity/manage/list", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async pick(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/pick/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async listForMain(idx: number, param: types.ReqCommonPaging): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/listForMain/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async changeOrder(param: types.ReqBoardForOrder): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/changeOrder", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async listForApply(idx: number, param: ReqBoardApplyList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/list/apply/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async listForPickApply(idx: number, param: ReqBoardApplyList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/list/apply/pick/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async listForApplyForEvent(idx: number, param: ReqBoardApplyList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/list/apply/campaign/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async listForPickApplyForEvent(idx: number, param: ReqBoardApplyList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/apply/pick/campaign/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async detail(type: number, idx: number): Promise<types.ResBoard> {
        const res = {} as types.ResBoard;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/detail/${type}/${idx}`, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async addForActivity(param: types.ReqBoardForActivity): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/board/activity/add", formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async addForEvent(param: types.ReqBoardForEvent): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/board/event/add", formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async addForNews(param: types.ReqBoardForNews): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/board/news/add", formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modifyForActivity(idx: number, param: types.ReqBoardForActivityForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            // header.headers["Content-Type"] = "application/json";

            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/board/activity/modify/" + idx, formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modifyForEvent(idx: number, param: types.ReqBoardForEventForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            // header.headers["Content-Type"] = "application/json";

            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/board/event/modify/" + idx, formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modifyForNews(idx: number, param: types.ReqBoardForNewsForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            // header.headers["Content-Type"] = "application/json";

            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/board/news/modify/" + idx, formData, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async remove(param: types.ReqIdxList): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/remove", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async exportExcelForNews(param: types.ReqNewsForExcel): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/board/export/news/excel", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async exportExcelForEvent(param: types.ReqNewsForExcel): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/board/export/event/excel", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async removeFile(idx: number, idxFile: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/remove/" + idx + "/" + idxFile, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async exportExcelForActivityManage(param: types.ReqActivityManageForExcel): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/board/export/activity/manage/excel", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error.response);
            res = error.response.data;
        }
        return res;
    },

    async applyPick(idx: number, param: types.ReqBoardApplyPick): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/apply/pick/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async multiApplyPick(idx: number, param: types.ReqCampaignApplyUpdate): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/apply/campaign/pick/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modifyForMemo(param: types.ReqBoardForMemoForModify): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/modify/memo", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async exportExcelForActivityApply(type: number, idx: number): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/board/export/apply/excel/" + type + "/" + idx, null, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async exportExcelForEventApply(type: number, idx: number): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/board/export/excel/apply/campaign/" + type + "/" + idx, null, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async listForForm(idx: number): Promise<types.ResBoardApplyFormList> {
        let res = {} as types.ResBoardApplyFormList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/apply/form/list/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async answerForForm(boIdx: number, meIdx: number): Promise<types.ResBoardApplyFormDetail> {
        let res = {} as types.ResBoardApplyFormDetail;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/board/apply/form/detail",
                { boIdx, meIdx },
                {
                    withCredentials: false,
                },
            );

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async addForm(param: types.ReqBoardApplyForm): Promise<types.BaseResponse> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/apply/form/add", param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async modifyForm(param: types.ReqBoardApplyForm): Promise<types.BaseResponse> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/apply/form/modify", param, {
                withCredentials: false,
            });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async removeForm(idx: number): Promise<types.BaseResponse> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/apply/form/remove/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async isOrderForm(idx: number, order: number): Promise<types.BaseResponse> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/board/apply/form/isOrder",
                { idx, order },
                {
                    withCredentials: false,
                },
            );

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async listForCase(idx: number): Promise<types.ResBoardApplyCaseList> {
        let res = {} as types.ResBoardApplyCaseList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/apply/case/list/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async exportExcelForApply(idx: number): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/board/apply/export/excel/" + idx, null, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
